const accordionData = [
    {
      id: 1,
      title: "What is React?",
      content:
        "React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. It is maintained by Meta and a community of individual developers and companies.",
    },
    {
      id: 2,
      title: "Why use React?",
      content:
        "React allows developers to create large web applications that can update and render efficiently in response to data changes. Its component-based architecture enables reusability and faster development.",
    },
    {
      id: 3,
      title: "How does React work?",
      content:
        "React creates a virtual DOM to efficiently update the real DOM. When the state of an object changes, React updates the virtual DOM, then compares it with the previous version to determine the minimal number of changes needed in the real DOM.",
    },
    {
      id: 4,
      title: "What is JSX?",
      content:
        "JSX is a syntax extension for JavaScript. It looks similar to HTML but is used in React to describe what the UI should look like. JSX allows you to write HTML elements and components in JavaScript.",
    },
    {
      id: 5,
      title: "What are React Hooks?",
      content:
        "React Hooks are functions that let you use state and other React features without writing a class. Examples include useState, useEffect, and useContext.",
    },
  ];
  
  export default accordionData;
  